import { render, staticRenderFns } from "./ReviewSummaryTeaser.vue?vue&type=template&id=47688cc6&scoped=true&"
import script from "./ReviewSummaryTeaser.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewSummaryTeaser.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewSummaryTeaser.vue?vue&type=style&index=0&id=47688cc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47688cc6",
  null
  
)

export default component.exports